export enum PageCenter {
  CENTRE_AIDE = "CENTRE_AIDE",
  TUTORIAL_EXEMPLE = "TUTORIAL_EXEMPLE",
  AIDE_PARAMETRAGE = "AIDE_PARAMETRAGE",
}
